import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthState } from '../context/AuthContext';
import PageLoader from './PageLoader';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuthState();

  if (loading) {
    return <PageLoader text="Loading..." />;
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
